/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMeetingResponseDto
 */
export interface GetMeetingResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    id?: string;
    /**
     * Meeting creator user id
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    creator?: string;
    /**
     * Meeting title
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    title?: string;
    /**
     * Token to access web meeting
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    token?: string;
    /**
     * Start time of the meeting
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    startTime?: string;
    /**
     * End time of the meeting
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    endTime?: string;
    /**
     * Meeting Id in third-party calendar
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    externalId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMeetingResponseDto
     */
    participants?: Array<string>;
    /**
     * Was the meeting canceled?
     * @type {boolean}
     * @memberof GetMeetingResponseDto
     */
    canceled?: boolean;
    /**
     * Room name for meeting
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    roomName?: string;
    /**
     * Workflow instance Id in which context the meeting is scheduled
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    workflowInstanceId?: string;
    /**
     * Organization Id for whose benefit the meeting is performed
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    orgId?: string;
    /**
     * Org lei
     * @type {string}
     * @memberof GetMeetingResponseDto
     */
    lei?: string;
}

/**
 * Check if a given object implements the GetMeetingResponseDto interface.
 */
export function instanceOfGetMeetingResponseDto(value: object): boolean {
    return true;
}

export function GetMeetingResponseDtoFromJSON(json: any): GetMeetingResponseDto {
    return GetMeetingResponseDtoFromJSONTyped(json, false);
}

export function GetMeetingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeetingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'creator': json['creator'] == null ? undefined : json['creator'],
        'title': json['title'] == null ? undefined : json['title'],
        'token': json['token'] == null ? undefined : json['token'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'participants': json['participants'] == null ? undefined : json['participants'],
        'canceled': json['canceled'] == null ? undefined : json['canceled'],
        'roomName': json['roomName'] == null ? undefined : json['roomName'],
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'lei': json['lei'] == null ? undefined : json['lei'],
    };
}

export function GetMeetingResponseDtoToJSON(value?: GetMeetingResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'creator': value['creator'],
        'title': value['title'],
        'token': value['token'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'externalId': value['externalId'],
        'participants': value['participants'],
        'canceled': value['canceled'],
        'roomName': value['roomName'],
        'workflowInstanceId': value['workflowInstanceId'],
        'orgId': value['orgId'],
        'lei': value['lei'],
    };
}

